import script from "./BaseSelectBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSelectBox.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSelectBox.vue?vue&type=style&index=0&id=ab958880&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab958880"]])

export default __exports__